import { Result } from '@blade/std-lib'
import { loadScript } from '@root/shared/core/DomUtil'
import { LoadScriptError } from '@root/shared/core/script-loader/script-loader'

declare global {
  interface Window {
    twttr?: Twitter
  }
}
const twitterWidgetJs = 'https://platform.twitter.com/widgets.js'

let twitterWidgetPromise:
  | Promise<Result.Result<TwitterWidgets, LoadScriptError>>
  | undefined

export const loadXWidget = () => {
  if (twitterWidgetPromise) {
    return twitterWidgetPromise
  }

  twitterWidgetPromise = new Promise<
    Result.Result<TwitterWidgets, LoadScriptError>
  >((resolve) => {
    loadScript(twitterWidgetJs, {
      async: true,
    }).then((result) => {
      if (Result.isFailure(result)) {
        twitterWidgetPromise = undefined
        resolve(Result.fail(result.failure))

        return
      }

      if (!window.twttr) {
        resolve(
          Result.fail(
            new LoadScriptError({
              src: twitterWidgetJs,
              cause: 'window.twttr is undefined',
            }),
          ),
        )

        return
      }

      const twttr = window.twttr

      twttr.ready(() => {
        resolve(Result.succeed(twttr.widgets))
      })
    })
  })

  return twitterWidgetPromise
}

interface Twitter {
  ready: (callback: (twttr: Twitter) => void) => void

  widgets: TwitterWidgets
}
export interface TwitterWidgets {
  createTweet: (
    tweetId: string,
    target: HTMLElement,
    options?: Record<string, unknown>,
  ) => Promise<HTMLElement>
}

export interface TwitterTweetEmbedProps {
  tweetId: string
  options?: Record<string, unknown>
  placeholder?: React.ReactNode
  onLoad?: (element: HTMLElement) => void
  onError?: (error: unknown) => void
}
